import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { RootState } from "../store/store";
import FeatureCard from "../components/FeatureCard";
import contentMasterIllustration from "../assets/img/Illustration-Content_master.png";
import gpsrIllustration from "../assets/img/Illustration-gpsr.png";
import lieferbarIllustration from "../assets/img/Illustration-lieferbar.png";
import shipmentTrackerIllustration from "../assets/img/Illustration-shipment-tracker.png";
import googleReviewIllustration from "../assets/img/Illustration-google-review-manager.png";

const FeaturesPage: React.FC = () => {
  const { t } = useTranslation();
  const user = useSelector((state: RootState) => state.auth.user);

  const isAntonUser =
    user?.email === "antonfauser@gmail.com" ||
    user?.email === "reymoleg@gmail.com" ||
    user?.email === "workboxmain1@gmail.com";

  return (
    <div>
      <h1>{t("features_menu")}</h1>
      <div className="features-grid">
        {/* TODO: decide if ConnectorsPage is still needed or we put 
        everything inlcuding freshdesk and mobile-app here in FeaturesPages 
        (in which case uncomment this below) */}
        {/* <FeatureCard
          key="freshdesk"
          title={t('dashboard_freshdesk_title')}
          description={t('dashboard_freshdesk_description')}
          illustration={freshdeskIllustration}
          pluginName="freshdesk"
          to="/features/freshdesk"
          isComingSoon={false}
          isBuyWithoutFilling={false}
        />
        <FeatureCard
          key="mobile-app"
          title={t('dashboard_mobile_app_title')}
          description={t('dashboard_mobile_app_description')}
          illustration={mobileIllustration}
          pluginName="mobile"
          to="/features/mobile-app"
          isComingSoon={false}
          isBuyWithoutFilling={true}
        /> */}
        <FeatureCard
          key="content-master"
          title={t("dashboard_content_master_title")}
          description={t("dashboard_content_master_description")}
          illustration={contentMasterIllustration}
          pluginName="content_master"
          to="/features/content-master"
          isComingSoon={false}
          isBuyWithoutFilling={false}
        />
        <FeatureCard
          key="lieferbar"
          title={t("lieferbar_card_title")}
          description={t("lieferbar_card_desc")}
          illustration={lieferbarIllustration}
          pluginName="mobile"
          to="/features/lieferbar"
          isComingSoon={false}
          isBuyWithoutFilling={true}
        />
        {isAntonUser && (
          <FeatureCard
            key="gpsr"
            title={t("gpsr:dashboard_title")}
            description={t("gpsr:dashboard_description")}
            illustration={gpsrIllustration}
            pluginName="gpsr"
            to="/features/gpsr"
            isComingSoon={false}
            isBuyWithoutFilling={true}
          />
        )}
        <FeatureCard
          key="shipment-tracker"
          title={t("shipment_tracker_card_title")}
          description={t("shipment_tracker_card_description")}
          illustration={shipmentTrackerIllustration}
          illustrationScale={1.1}
          pluginName="shipment_tracker"
          to="/features/shipment-tracker"
          isComingSoon={false}
          isBuyWithoutFilling={true}
        />
        <FeatureCard
          key="google-review-manager"
          title={t("google_review_card_title")}
          description={t("google_review_card_description")}
          illustration={googleReviewIllustration}
          illustrationScale={1.2}
          pluginName="google_review_manager"
          to="/features/google-review-manager"
          isComingSoon={false}
          isBuyWithoutFilling={true}
        />
      </div>
    </div>
  );
};

export default FeaturesPage;
